import React from "react";


const studentData = [
    {
        heading:"How many items can a customer store?",
        body:<p>
        Customers can store as many items as they wish, but we charge by the item. There is no maximum number of items, but there is a $100 minimum for any storage order.
        </p>
    },
    {
        heading:"Do I have to know exactly how many items I am going to store before signing up?",
        body:<p>
        No, a rough estimate of the items you plan to store is fine.
        </p>,
    },
    {
        heading:"Do you pickup and deliver storage off-campus?",
        body:<p>
            Yes. Lazybones can pickup your storage whether you live in a dorm or an off-campus apartment. If you live more than 5 miles from a campus we service, we may not be able to provide storage services to you. Call us or email us with your address to find out.
         </p>,
    },
    {
        heading:"What days of the week do you do storage pickups during move out week?",
        body:<p>
            We do storage pick-ups seven days a week during peak move out times, which are generally the week of finals and the week after.
        </p>,
    },
    {
        heading:"How many days in advance do I need to schedule my pickup?",
        body:<p>
        Customers need to schedule their storage pickup a minimum of 2 days in advance, but we recommend scheduling at least 3 weeks in advance to ensure you get the date and time you want. Pickups scheduled less than 48 hours in advance are subject to additional fees.
        </p>,
    },
    {
        heading:"What should I do if I know I will not be ready for my scheduled pickup?",
        body:<p>
        You should call us immediately, and we will try to reschedule you for a different pick-up window if possible.
        </p>,
    },
    {
        heading:"How long does it typically take for a storage pickup?",
        body:<p>
         Storage pickups typically takes 15-20 minutes depending on how many items a customer has to store and the size of your items.  Customers with many items or larger items take longer. 
        </p>,
    },
    {
        heading:"When do you do storage pickups?",
        body:<p>
        Lazybones does storage pickups all year round! 
        </p>,
    },
    {
        heading:"Can I schedule more than one storage pickup date?",
        body:<p>
        Customers can always ask for multiple pickups, however, there is a $100 minimum charge for storing the items for each storage pickup. For instance, if you have us do 3 different pickups, your minimum storage charge is going to be $300.
        </p>,
    },
    {
        heading:"Will Lazybones refund my $35 if I cancel my storage reservation?",
        body:<p>
        Lazybones will refund your $35 reservation fee as long as you cancel your reservation at least 48 hours before your storage pickup date. 
        </p>,
    },
    {
        heading:"What is the time frame for a storage pickup?",
        body:<p>
        We give the customer a three-hour window for storage pickups and deliveries.  The window is necessary for unforeseen issues that tend to occur during moving time such as, blocked vans, traffic, closed roads, or broken elevators. 
        </p>,
    },
    
];

const SchedulingPickup = ()=>{
    const data = studentData;
    let ctr = 1; 
    return(
        <>
            {
                data.map(({heading,body})=>
                    <div class="media" key={ctr++}>
                        <div class="media-body">
                            <h2 class="media-heading faq-title">{heading}</h2>
                            <p>{body}</p>
                        </div>
                    </div>
                )
            }
        </>
    );
}

export default SchedulingPickup;
